// extracted by mini-css-extract-plugin
module.exports = {"NotFoundPage":"notFoundPage_NotFoundPage__289HA"};